module.exports = __webpack_public_path__ + "media/images/favicon/primary/android-icon-48x48-7e16e0710dbb5e4ac516b7d769d56266.png";